/**
 * Section Component - Full-width container with background and spacing
 * Use for major page sections with optional styling
 */

import React from 'react';
import styles from './Section.module.css';

const Section = ({
  children,
  className = '',
  padding = 'medium', // 'none', 'small', 'medium', 'large', 'xlarge'
  maxWidth = 'container', // 'full', 'container' (1200px), 'narrow' (800px)
  background = 'transparent', // 'transparent', 'surface', 'gradient'
  backgroundColor,
  marginTop = 'none', // 'none', 'small', 'medium', 'large'
  marginBottom = 'none', // 'none', 'small', 'medium', 'large'
  style = {}
}) => {
  const sectionClasses = [
    styles.section,
    styles[`padding-${padding}`],
    styles[`maxWidth-${maxWidth}`],
    styles[`background-${background}`],
    marginTop !== 'none' && styles[`marginTop-${marginTop}`],
    marginBottom !== 'none' && styles[`marginBottom-${marginBottom}`],
    className
  ].filter(Boolean).join(' ');

  const customStyle = {
    ...style,
    ...(backgroundColor && { backgroundColor })
  };

  return (
    <div className={sectionClasses} style={customStyle}>
      {children}
    </div>
  );
};

export default Section;
